<ng-container *ngIf="!stacked; else stacked">
    <h2 [style.color]="color"><ng-content></ng-content></h2>
    <hr [style.borderColor]="color" />
</ng-container>
<ng-template #stacked>
    <div class = "stack">
        <h4 [style.color]="color"><ng-content></ng-content></h4>
        <div><hr [style.borderColor]="color" /></div>
    </div>
</ng-template>
